<template>
  
    <div class="wrapper">

      <!-- Main columns-->
      <div class="box main-col events">
        <div class="nes-container with-title is-rounded is-dark">
          <p class="title">Running Events</p>
          <div v-for="meetEvent in meet.runningEvents" :key="meetEvent.name" class="nes-container with-title is-rounded is-dark">
            <span class="title event-name">{{meetEvent.name}}</span>
            <div v-for="division in meetEvent.divisions" :key="`${meetEvent.name}-${division.type}`" class="nes-container is-rounded with-title is-dark heats">
              <p class="title division-title">{{division.type}}</p>
              <drop v-for="heat in division.heats" :key="`${meetEvent.name}-${division.gender}-${heat.name}`" 
                class="nes-container is-rounded is-dark heat"  
                :class="{ allowed: (dragging === division.gender || (dragging && division.gender === 'B')), dragOver:heat.dragOver}"
                @dragover="handleDragover(meetEvent,division,heat, ...arguments)"
                @dragleave="heat.dragOver = false"
                @drop="handleDrop(division,heat,...arguments)">
                  
                <span class="nes-badge heat-name">
                  <span :class="heatBadgeClass(heat.runners)">{{heat.name}}</span>
                </span>
                <div v-for="runner in heat.runners" :key="`${meetEvent.name}-${division.gender}-${heat.name}-${runner}`">
                  <button @click="clearRunner(heat, runner)" type="button" class="nes-btn is-error heat-clear">X</button> 
                   {{runner}}
                </div>
              </drop>
            </div>
          </div>
        </div>
        <div class="nes-container with-title is-rounded is-dark">
          <p class="title">Field Events</p>
          <div v-for="fieldEvent in meet.fieldEvents" :key="fieldEvent.name" class="nes-container with-title is-rounded is-dark">
            <span class="title event-name">{{fieldEvent.name}}</span>
            <drop v-for="(slot, index) in fieldEvent.slots" :key="`${fieldEvent.name}-${index}`"
              class="nes-container is-rounded is-dark heat"
              :class="{dragOver:slot.dragOver}"
              @dragover="handleFieldEventDragover(fieldEvent,slot, ...arguments)"
              @dragleave="slot.dragOver = false"
              @drop="handleDrop(fieldEvent,slot, ...arguments)">
              <button v-if="slot.runner" @click="clearRunner(slot)" type="button" class="nes-btn is-error heat-clear">X</button>   
              <span> {{slot.runner || '&lt;empty&gt;'}}</span>
            </drop>
          </div>
          
        </div>
      </div>
      <div class="box main-col roster">
        <div class="nes-container with-title is-rounded">
          <p class="title">Roster</p>
          <div class="nes-container with-title is-rounded roster-list">
            <p class="title">Girls</p>
            <drag v-for="runner in roster.girls" :key="runner.name" :transferData="runner" class="nes-container is-rounded runner" 
              @dragstart="dragging = runner.gender"
              @dragend="dragging = null">
              <span class="nes-badge heat-counter">
                  <span :class="runnerBadgeClass(countRunnerEvents(runner.name))">{{countRunnerEvents(runner.name)}}</span>
              </span>
              <img class="runner-events-icon" src="../assets/Retro-Block-Exclamation-icon.png"
                @mouseover="runnerInfoHover(runner, ...arguments)"
                @mouseleave="infoHover = false"
              />
              <span>{{runner.name}}</span>
            </drag>
          </div>
          <div class="nes-container with-title is-rounded roster-list">
            <p class="title">Boys</p> 
            <drag v-for="runner in roster.boys" :key="runner.name" :transferData="runner" class="nes-container is-rounded runner"
              @dragstart="dragging = runner.gender"
              @dragend="dragging = null">
              <span class="nes-badge heat-counter">
                  <span :class="runnerBadgeClass(countRunnerEvents(runner.name))">{{countRunnerEvents(runner.name)}}</span>
              </span>
              <img class="runner-events-icon" src="../assets/Retro-Block-Exclamation-icon.png"
                @mouseover="runnerInfoHover(runner, ...arguments)"
                @mouseleave="infoHover = false"
              />
              <span>{{runner.name}}</span>
            </drag>
          
          </div>
        </div>
        <div class="nes-container with-title is-rounded">
          <p class="title">Meet Info</p>
          <div>Team: {{meet.teamName}} Name: {{meet.meetName}} Date: {{meet.meetDate}}</div>
          <div>
            Print: 
            <button @click="print('lineup')" class="nes-btn is-primary">
              <img v-if="isPrinting.lineup" class="loader" :src="loader"/>
              <span v-else class="nex-text">Lineup</span>
            </button> 
            <button @click="print('ribbons')" class="nes-btn is-primary">
              <img v-if="isPrinting.ribbons" class="loader" :src="loader"/>
              <span v-else class="nex-text">Ribbons</span>
            </button> 
            <button @click="print('nametags')" class="nes-btn is-primary">
              <img v-if="isPrinting.nametags" class="loader" :src="loader"/>
              <span v-else class="nex-text">Name Tags</span>
            </button>
          </div>
          <div>
            Manage:
            <button @click="save()" class="nes-btn">Save</button>
            <button @click="load()" :disabled="!hasSavedMeet" class="nes-btn" :class="{'is-disabled': !hasSavedMeet}">Load</button>
          </div>
          <div>
            Share: 
            <button @click="share()" class="nes-btn is-primary">
              <img v-if="isPrinting.share" class="loader" :src="loader"/>
              <span v-else class="nex-text">Create Link</span>
            </button>
          </div>

        </div>
        <div class="nes-container with-title is-rounded info-hover" ref="runnerHover"
          :class="{'hoverActive':infoHover}">
          <p class="title">{{hoverDataTitle}}</p>
          <div v-for="evt in hoverData" :key="evt.name" class="nes-text"
          :class="{'is-diabled':!evt.hasRunner, 'is-success':evt.hasRunner}">{{evt.name}}</div>
        </div>
      </div>
      <dialog class="nes-dialog is-rounded" ref="shareDialog">
        <p class="title">Share Link</p>
        <span class="nex-text">{{shareLink}}</span>
        <button @click="openShareLink" class="nes-btn">Open Link</button>
        <menu class="dialog-menu">
          <button @click="closeDialog" class="nes-btn">Close</button>
        </menu>
    </dialog>
    </div>

</template>

<script>
import { Drag, Drop } from 'vue-drag-drop';
import prek from '../config/prek.json';
import second from '../config/2nd3rd.json';
import fourth from '../config/4th6th.json';
import marioLoader from '../assets/mario.gif';
const axios = require('axios');

const config = {
  "prek":prek,
  "2nd3rd":second,
  "4th6th":fourth
};

export default {
  name: 'MeetAssignment',
  components: { Drag, Drop },
  data() {
    return {
      dragOver: false,
      dragging: null,
      infoHover: false,
      hoverData: [],
      hoverDataTitle: '',
      meet: {
        runningEvents:[],
        fieldEvents:[]
      },
      roster: {
        girls: [],
        boys: []
      },
      isPrinting: {
        lineup: false,
        ribbons: false,
        nametags: false,
        share: false
      },
      loader: marioLoader,
      shareLink:''
    };
  },
  watch: {
    // eslint-disable-next-line
    meet: function(newMeet, oldMeet) {
      console.log('Meet changed: ', newMeet);
      //save into local storage to help with testing
      //window.localStorage.setItem('savedMeet', newMeet);
    }
  },
  mounted () {
    this.roster = this.$store.state.newRoster;
    const meetParams = this.$store.state.meetParams;
    const meetConf = config[meetParams.ageGroup];
    this.meet = {
      ...meetParams,
      runningEvents:[],
      fieldEvents:[]
    };
    //running events
    for(let i=0;i<meetConf.runningEvents.length;i++) {
      let runningEvent = meetConf.runningEvents[i];
      let newEvent = {
        name:runningEvent.name,
        type:runningEvent.type,
        divisions:[]
      };
      const eventType = runningEvent.type;
      //add in distance events based on which meet it is
      if((eventType === 'distance' && runningEvent.allowedMeets.includes(meetParams.meetName)) || eventType !== 'distance')
      {
        for(let j=0;j<runningEvent.divisions.length;j++) {
          let division = runningEvent.divisions[j];
          division.heats = [];
          for(let h=1; h <= division.numHeats;h++) {
            const heatName = (eventType === 'individual' || eventType === 'hurdles') ? `Heat ${h}` : `#${h}`;
            division.heats.push({name:heatName, runners:[], dragOver:false});
          }
          //console.log('Division: ', division);
          newEvent.divisions.push(division);
        }
        //console.log('Event: ',newEvent);
        this.meet.runningEvents.push(newEvent);
      }
    }
    //field events
    for(let i=0;i<meetConf.fieldEvents.length;i++) {
      let fieldEvent = meetConf.fieldEvents[i];
      fieldEvent.slots = [];
      for(let j=1; j<=fieldEvent.numSlots;j++) {
        fieldEvent.slots.push({runner:'',dragOver:false});
      }
      this.meet.fieldEvents.push(fieldEvent);
    }

  },
  computed: {
    hasSavedMeet () {
      const savedMeet = window.localStorage.getItem(`savedMeet-${this.meet.ageGroup}-${this.meet.meetName}`);
      return (savedMeet) ? true: false;
    },
  },
  methods: {
    handleDragover(meetEvent, division, heat, data, event) {
      let runnerInEvent = false;
      let isTeam = (meetEvent.type === 'relay' || meetEvent.type === 'shuttle');
      let heatFull = ((isTeam && heat.runners.length >= 1) || (!isTeam && heat.runners.length >=2));
      for(let i=0;i<division.heats.length;i++) {
        let h = division.heats[i];
        
        //don't allow drop if runner is already in heat or if already has 2 runners
        if(h.runners.includes(data.name)) {
          runnerInEvent = true;
          break;
        }
      }
      if ((division.gender !== data.gender && division.gender !== 'B') || runnerInEvent || heatFull) {
        event.dataTransfer.dropEffect = 'none';
      }
      else {
        heat.dragOver = true;
      }
    },
    handleFieldEventDragover(fieldEvent,slot,data,event) {
      let runnerInEvent = false;
      for(let i=0;i<fieldEvent.slots.length;i++) {
        let h = fieldEvent.slots[i];
        if(h.runner === data.name) {
          runnerInEvent = true;
          break;
        }
      }
      if(runnerInEvent) {
        event.dataTransfer.dropEffect = 'none';
      }
      else {
        slot.dragOver = true;
      }
    },
    handleDrop(division, heat, data) {

      heat.dragOver = false;
      if(heat.runners) {
        heat.runners.push(data.name);
      } else {
        heat.runner = data.name;
      }
      
			//alert(`You dropped with data: ${JSON.stringify(data)}`);
		},
    heatBadgeClass(runners) {
      if(runners.length > 0) {
        return 'is-success';
      }
      else {
        return 'is-warning';
      }
    },
    clearRunner(heat, runner) {
      if(runner) {
        //running event
        
        heat.runners = heat.runners.filter(val => val !== runner);
        //heat.runners = [];
      } else {
        //field event
        heat.runner = '';
      } 
    },
    runnerBadgeClass(numEvents) {
      let className = '';
      switch(numEvents) {
        case 4:
          className = 'is-success';
          break;
        case 3:
        case 2:
          className = 'is-warning';
          break;
        case 1:
        case 0:
          className = 'is-error';
          break;
      }
      return className;
    },
    getRunnerEvents(runnerName) {
      let runnerEvents = [];
      for(let i=0;i<this.meet.runningEvents.length;i++) {
        let runningEvent = this.meet.runningEvents[i];
        for(let j=0;j<runningEvent.divisions.length;j++) {
          let division = runningEvent.divisions[j];
          for(let k=0;k<division.heats.length;k++) {
            let heat = division.heats[k];
            if(heat.runners.includes(runnerName)){
              runnerEvents.push(runningEvent.name);
            }
          }
        }
      }
      return runnerEvents;
    },
    countRunnerEvents(runnerName) {
      //loop meet events and count the names
      let runnerEvents = this.getRunnerEvents(runnerName);
      return(runnerEvents.length);
    },

    runnerInfoHover(runner, event) {
      //console.log('runnerInfoHover: ', runner, event);
      let runnerEvents = this.getRunnerEvents(runner.name);
      let hData = [];
      for(let i=0;i<this.meet.runningEvents.length;i++) {
        let runningEvent = this.meet.runningEvents[i];
        let evt = {name:runningEvent.name, hasRunner:false};
        if(runnerEvents.includes(runningEvent.name)){
          evt.hasRunner = true;
        }
        hData.push(evt);
      }
      this.hoverData = hData;
      this.hoverDataTitle = `${runner.name}'s Events`;
      this.$refs.runnerHover.style.top = event.clientY + 'px';
      this.$refs.runnerHover.style.left = (event.clientX - 400) + 'px';
      this.infoHover = true;

    },
    openShareLink() {
      window.open(this.shareLink, '_blank')
    },
    save() {
      window.localStorage.setItem(`savedMeet-${this.meet.ageGroup}-${this.meet.meetName}`, JSON.stringify(this.meet));
    },
    load() {
      const savedMeet = window.localStorage.getItem(`savedMeet-${this.meet.ageGroup}-${this.meet.meetName}`);
      if(savedMeet) this.meet = JSON.parse(savedMeet);
    },
    showDialog () {
      this.$refs.shareDialog.showModal();
    },
    closeDialog() {
      this.$refs.shareDialog.close();
    },
    share() {
      this.isPrinting['share'] = true;
      let payload = {
        data: this.meet
      };
      axios.post('https://us-central1-track-manager.cloudfunctions.net/share', payload).then((resp) => {
        this.isPrinting['share'] = false;
        console.log(`share response:`, resp);
        let id = resp.data.id;
        //alert(`http://localhost:3001/meet/view/${id}`);
        this.shareLink = `https://track-manager.web.app/meet/view/${id}`;
        this.showDialog();
      }).catch((err) => {
        this.isPrinting['share'] = false;
        console.log(`share error:`, err);
        alert(`There was an error generating the share link.`);
      });
    },
    print(type) {
      //TODO: validate all runners have 4 events
      //TODO: make sure field events are populated
      this.isPrinting[type] = true;
      let payload = {
        type,
        data: {
          roster: this.roster,
          meet: this.meet
        }
      };
      axios.post('https://us-central1-track-manager.cloudfunctions.net/print', payload).then((resp) => {
        this.isPrinting[type] = false;
        console.log(`print '${type}' response:`, resp);
        let url = resp.data.url[0];
        window.open(url, '_blank');
      }).catch((err) => {
        this.isPrinting[type] = false;
        console.log(`print '${type}' error:`, err);
        alert(`There was an error generating the ${type}. Double check that all your runners have 4 races and try again.`);
      });
    }  
  } 
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


    .wrapper {
      display: grid;
      grid-template-columns: 50% 50%;
    }



    .box {
      padding: .5em;
    }

    .events {
      overflow-y:scroll;
      height: 84vh;
    }

    .event-name {
      color: #209cee !important;
    } 

    .division-title {
      color: #92cc41 !important;
    }

    .heat {
      padding: .5rem 1rem !important;
    }

    .runner {
      background-color: white;
      padding: 0 1rem !important;
    }

    .heat-name {
      font-size:0.6em;
    }
    .heat-counter {
      float:right;
      font-size:0.6em;
      width:2.5em;
    }
    .heat-clear {
      float:right;
      font-size: .4em;
      margin: 0;
      padding: 3px 4px;
    }
    .heat.allowed {
      background-color: aqua;
    }

    .heat.dragOver {
      background-color: darkgreen;
    }

    .runner-events-icon {
      width: 1.5em;
      height: 1.5em;
      float: right;
      margin-right: 10px;
    }
    .info-hover {
      display: none;
      position: absolute;
      background-color: white;
    }
    .info-hover.hoverActive {
      display:block;
    }
    /* .roster {
        top:20px;
        position: sticky;
    } */
</style>
